var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEmptySearch(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 144,
    height: 144,
    viewBox: "0 0 144 144",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M87.3902 20.7303V13.0803H21.2402V105.93H34.6502",
    stroke: "#24293D",
    strokeWidth: 4.5,
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M108.361 65.1899V26.9099H59.5811L36.6611 50.0699V53.2799V81.2699",
    stroke: "#24293D",
    strokeWidth: 4.5,
    strokeMiterlimit: 10
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M36.6611 86.6097V114.66H66.6911",
    stroke: "#24293D",
    strokeWidth: 4.5,
    strokeMiterlimit: 10
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M59.5811 26.9099V50.7299H36.6611",
    stroke: "#24293D",
    strokeWidth: 4.5,
    strokeMiterlimit: 10
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M88.9788 95.4001H84.3888L78.7188 89.7301L76.4388 87.4201L68.5488 79.5001H73.0488L78.7188 85.1701L80.9988 87.4201L88.9788 95.4001Z",
    fill: "#24293D"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M75.3295 88.6502L77.5795 90.9002L73.0795 95.4002H68.5195L75.2995 88.6202L75.3295 88.6502Z",
    fill: "#24293D"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M88.9801 79.5001L79.8601 88.6201L77.6101 86.4001L77.5801 86.3701L84.4201 79.5001H88.9801Z",
    fill: "#24293D"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M78.751 109.05C73.171 109.05 67.591 106.95 63.301 102.72C59.101 98.5803 56.791 93.0903 56.761 87.2102C56.731 81.3302 58.981 75.7803 63.091 71.6103C67.231 67.4103 72.721 65.1003 78.601 65.0703C84.421 65.0103 90.031 67.2903 94.201 71.4002C102.841 79.9202 102.931 93.8703 94.411 102.54C90.121 106.89 84.421 109.08 78.751 109.08V109.05ZM78.751 69.5403H78.631C73.951 69.5703 69.571 71.4303 66.301 74.7603C59.521 81.6303 59.611 92.7302 66.481 99.5102C73.351 106.29 84.451 106.2 91.231 99.3303C98.011 92.4603 97.921 81.3603 91.051 74.5803C87.751 71.3103 83.401 69.5403 78.751 69.5403Z",
    fill: "#24293D"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M120.81 128.88C119.49 130.23 117.72 130.92 115.98 130.92C114.24 130.92 112.53 130.26 111.21 128.97L91.5 109.32C92.82 108.6 94.08 107.73 95.28 106.74L114.36 125.76C115.26 126.63 116.73 126.63 117.63 125.73C118.5 124.83 118.5 123.36 117.6 122.46L98.46 103.5C99.42 102.3 100.26 101.01 100.98 99.6599L120.75 119.28C123.42 121.89 123.45 126.21 120.81 128.88Z",
    fill: "#24293D"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M93.0002 116.91H54.9902V112.44H88.5002L93.0002 116.91Z",
    fill: "#24293D"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M110.61 58.6802V102.48L106.11 97.9802V58.6802H110.61Z",
    fill: "#24293D"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmptySearch);
export default __webpack_public_path__ + "static/media/emptySearch.166b1bee95d7c5157baa2b9b98bccb4d.svg";
export { ForwardRef as ReactComponent };